import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'
import { reduxForm, InjectedFormProps, FormErrors, formValueSelector, SubmissionError } from 'redux-form'

import { AppState } from "store";
import targetComponent from 'components/student/StudyLogQuestionForm';
import studentActions from 'actions/studentActions';
import * as Models from 'models/api';

type FormData = {
  content_id?: number;
  body?: string;
  attachment?: { data: string; file: File; };
  [key: string]: any
};

export const formKey = 'question_create'

export const FormValidate = (values: FormData) => {
  const errors: FormErrors<FormData> = {}
  const requiredFields: string[] = [
    'body',
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  })
  if (values.body && values.body.length > 2000) {
    errors.body = 'Invalid'
  }
  return errors
}

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  const selector = formValueSelector(formKey);
  const questionBody = selector(appState, 'body');
  const questionAttachment = selector(appState, 'attachment') as { data: string; file: File } | null;

  const user = appState.session.user! as Models.StudentUser
  return {
    user,
    student: appState.student,
    questionBody,
    questionAttachment,
    ...ownProps,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {
  return {
    ...stateProps,
    fetchData: (study_log_id: number) => {
      dispatch(studentActions.fetchQuestionsSheetsCountInMonth())
      dispatch(studentActions.fetchStudyLogDetail({ study_log_id }))
    },
    getRecord: (study_log_id: number) => {
      const page = stateProps.student.studyLogDetail
      if (page.study_log_id !== study_log_id) {
        return null
      }
      return page.record
    },
    onSubmit: (values: FormData) => {
      const page = stateProps.student.studyLogDetail
      const body = values.body!
      const attachment = values.attachment
      const content_id = page.record!.content.id
      return new Promise<void>((resolve, reject) => {
        dispatch(studentActions.createQuestion({
          params: {
            question: {
              content_id: content_id,
              body: body,
              body_attachment: attachment? {
                encoded_file: attachment.data,
                mime_type: attachment.file.type,
                file_name: attachment.file.name,
                file_size: attachment.file.size,
              } : undefined,
            },
          },
          promises: { resolve, reject }
        }))
      }).catch((e: Error) => {
        throw new SubmissionError({})
      })
    }
  }
}

type connectMappedProps = ReturnType<typeof mergeProps>
export type mappedProps = connectMappedProps & InjectedFormProps<FormData, connectMappedProps>

const form = reduxForm<FormData, connectMappedProps>({
  form: formKey,
  validate: FormValidate
})(targetComponent)

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(form))
